module.exports = "/images/checkoutCash.svg";